import { render, staticRenderFns } from "./TableListCdp.vue?vue&type=template&id=6a246470&"
import script from "./TableListCdp.vue?vue&type=script&lang=ts&"
export * from "./TableListCdp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports